(function (angular) {

    'use strict';

    angular.module('harriMainApp').controller('LmsPromoModal', LmsPromoModal);

    LmsPromoModal.$inject = ['$scope', '$q', 'modalData', 'hUser', 'brandServices', 'announcementsService'];

    function LmsPromoModal($scope, $q, modalData, hUser, brandServices, announcementsService) {
        var self = this;

        var requestedDemo = false;
        self.dontShow = false;

        self.hideModal = function () {
            updateStatusFlag();
            $scope.$hide();
        };


        var updateStatusFlag = function () {
            var defer = $q.defer();

            if (self.dontShow || requestedDemo) {
                announcementsService.dismiss(announcementsService.LMS_HARASSMENT)
                    .then(function (res) {
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            } else {
                defer.resolve();
            }

            return defer.promise;
        };

        self.scheduleDemo = function () {
            var defer = $q.defer();

            self.sendingRequest = true;
            announcementsService.requestDemo(hUser.getUserContext().brand_id, announcementsService.LMS_HARASSMENT)
                .then(function (res) {
                    requestedDemo = true;
                    self.hideModal();
                    modalData.onSuccess && modalData.onSuccess(requestedDemo);
                })
                .catch(function (err) {

                    hAlert(
                        $filter("translate")("Something Went Wrong"),
                        $filter("translate")("Please try again later.")
                    );

                    console.log(err);
                })
                .finally(function () {
                    delete self.sendingRequest;
                    $scope.$digest();
                });

            return defer.promise;
        };
    }
})(angular);